export default __webpack_public_path__ + "static/media/calendar.027d24fa.svg";